<template>
  <DrawActivity />
</template>

<script>
import DrawActivity from "place/drawactivity/DrawActivity.vue";
export default {
  data() {
    return {};
  },
  components: {
    DrawActivity,
  },
};
</script>
<style lang="" scoped></style>
